import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-joining',
  templateUrl: './joining.component.html',
  styleUrls: ['./joining.component.scss']
})
export class JoiningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
